const PREFIX = 'job-';
const RANDOM_PART_LENGTH = 11;

export const generateJobReference = () => {
    const randomHex = crypto.randomUUID().replace(/-/g, '');
    const randomPart = randomHex.slice(0, RANDOM_PART_LENGTH);

    return `${PREFIX}${randomPart}`;
};
